import React from 'react';
import * as FjPrimitives from 'components/primitives';
import classnames from 'classnames';
import './loading.css';

interface LoadingProps {
  message?: string;
  className?: string;
}

export const Loading = ({ message = 'Waiting for data...', className }: LoadingProps): React.ReactElement => (
  <div className={classnames('loading__container', className)}>
    <FjPrimitives.FjSpinner />
    <div className="loading__text">{message}</div>
  </div>
);

export default Loading;
